// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HeaderedContentBox > .HeaderedContent {\n  max-height: 100%;\n}", "",{"version":3,"sources":["webpack://./components/HeaderedContentBox/index.sass"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ","sourcesContent":[".HeaderedContentBox\n  > .HeaderedContent\n    max-height: 100%\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
